import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { ExerciseFilterDto } from '../../../shared/dtos/exerciseFilter.dto';
import { useAuthFetchFromRestAPI } from '../util/api';

export const exerciseFilterQueryKeys = {
  all: ['exercise-filters'] as const,
}

export function useExerciseFilters(enabled: boolean = true): UseQueryResult<ExerciseFilterDto> {
  const { authFetch } = useAuthFetchFromRestAPI();

  return useQuery({
    queryKey: exerciseFilterQueryKeys.all,
    queryFn: async (): Promise<ExerciseFilterDto> => {
      try {
        return await authFetch('/api/v1/exercise/filters', { method: 'GET' });
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    enabled,
    staleTime: 1000 * 60 * 10,
    gcTime: 1000 * 60 * 30,
  })
}
